module.exports = __webpack_public_path__ + "img/1F1E7-1F1F9.fa8bc95d.svg";